import Cookies from 'js-cookie';
import { CookieNames, Language } from 'config/constants';

export type AppLang = 'ru' | 'be';

export const getCurrentLang = ():AppLang => Cookies.get(CookieNames.Language) as AppLang || Language.Default;
